<template>
    <div
        data-testid="step-newAccount"
        class="container new-account"
        :class="isOpenOverlay ? 'first-step' : ''"
    >
        <RodoInformation
            :is-open="isRodoInformationOpen"
            @close="handleModal"
        />
        <UkraineResidenceInfo
            :is-open="isUkraineResidenceInfoOpen"
            @close="handleUkraineResidenceInfoOpen"
        />
        <div
            v-if="
                !isOpenOverlay &&
                isConfirmResidence &&
                !isChooselanguageRequired
            "
        >
            <h1 class="new-account__h1">
                {{ $t(`${TRANSLATION_KEY}.createNewAccount`) }}
            </h1>
            <div class="container__main-paragraph">
                <span>
                    {{ $t(`${TRANSLATION_KEY}.alreadyHaveAccount`) }}
                </span>
                <router-link to="/login" @click="() => handleClick()">
                    {{ $t(`${TRANSLATION_KEY}.logInToYourAccount`) }}
                </router-link>
            </div>
        </div>
        <form @submit.prevent>
            <div v-if="isOpenOverlay" class="onboarding-information-overlay">
                <div
                    v-show="!showUaPopup"
                    class="onboarding-information-welcome"
                >
                    <div
                        class="onboarding-information-overlay__short-information"
                        v-html="$t(`${TRANSLATION_KEY}.beReadyHookHeader`)"
                    />
                    <div
                        class="onboarding-information-overlay__short-information"
                        v-html="$t(`${TRANSLATION_KEY}.beReadyHook`)"
                    />
                    <div v-show="isSamsung">
                        <img
                            :src="getMobilePoster()"
                            class="samsung-mobile"
                            alt=""
                        />
                    </div>
                    <div v-show="!isSamsung">
                        <video
                            v-if="isMobile"
                            ref="videoEl"
                            muted
                            playsinline
                            :src="videoMobileUrl"
                            @error="handleVideoError"
                        />
                        <video
                            v-else
                            ref="videoEl"
                            muted
                            playsinline
                            :src="videoDesktopUrl"
                            @error="handleVideoError"
                        />
                    </div>
                </div>
                <div v-show="!isChooselanguageRequired">
                    <UkraineResidencePopup
                        v-show="showUaPopup"
                        @yes-eu-address="yesEuAddress"
                    />
                    <h1
                        v-if="!isOpenOverlay && !isConfirmResidence"
                        class="new-account__h1"
                    >
                        {{ $t(`${TRANSLATION_KEY}.countryOfResidenceTitle`) }}
                    </h1>
                    <div
                        v-if="isResidenceConfirmRadioRequired"
                        v-show="!showUaPopup"
                        class="row"
                    >
                        <p class="new-account__question">
                            {{ $t(`${TRANSLATION_KEY}.residenceConfirmText`) }}
                        </p>
                        <div
                            class="field--poland-tax-residence-field__radios new-account__radios"
                        >
                            <Radio
                                v-if="UtilityHelper.getLocale() === Locale.UA"
                                :label="
                                    $t(`${TRANSLATION_KEY}.residenceConfirmYes`)
                                "
                                name="residenceConfirm"
                                :value="true"
                                :checked="formData.residenceConfirm === true"
                                @update-value="
                                    ($event) => updateResidenceConfirm($event)
                                "
                            />
                            <Radio
                                v-else
                                :label="
                                    $t(`${TRANSLATION_KEY}.residenceConfirmYes`)
                                "
                                name="residenceConfirm"
                                :value="true"
                                :checked="formData.residenceConfirm === true"
                                @update-value="
                                    ($event) =>
                                        updateResidenceConfirm($event, true)
                                "
                            />
                            <Radio
                                :label="
                                    $t(`${TRANSLATION_KEY}.residenceConfirmNo`)
                                "
                                name="residenceConfirm"
                                :value="false"
                                :handles-error="false"
                                :checked="formData.residenceConfirm === false"
                                @update-value="
                                    ($event) => updateResidenceConfirm($event)
                                "
                            />
                        </div>
                    </div>
                    <div
                        v-if="isSelectResidenceRequired && !showUaPopup"
                        class="row"
                    >
                        <p class="new-account__question">
                            {{
                                $t(
                                    `${TRANSLATION_KEY}.residenceConfirmSelectText`
                                )
                            }}
                        </p>
                        <div class="row custom-select-wrapper">
                            <TheCountrySelect
                                v-model="formData.residenceCountry"
                                name="residenceCountry"
                                :default-value="defaultCountry"
                                :country-list="countries"
                                :label="
                                    $t(`${TRANSLATION_KEY}.countrySelectLabel`)
                                "
                                :placeholder="
                                    $t(
                                        `${TRANSLATION_KEY}.countrySelectPlaceholder`
                                    )
                                "
                                class="custom-select"
                                @selected-country="
                                    ($event) =>
                                        (formData.residenceCountry = $event)
                                "
                            />
                        </div>
                        <div v-show="isProhibitedCountry">
                            <p class="new-account__prohibited-warning">
                                {{
                                    $t(
                                        `${TRANSLATION_KEY}.prohibitedCountryInfo`
                                    )
                                }}
                            </p>
                        </div>
                    </div>
                    <button
                        v-if="!showUaPopup"
                        type="button"
                        class="button button--submit"
                        data-testid="btn-newAccount-confirmResidence"
                        :disabled="
                            !(
                                formData.residenceConfirm ||
                                (isSelectResidenceRequired &&
                                    formData.residenceCountry &&
                                    !isProhibitedCountry)
                            )
                        "
                        @click="handleResidenceConfirm"
                    >
                        {{ $t(`${TRANSLATION_KEY}.saveAndContinue`) }}
                    </button>
                </div>
            </div>
            <div v-show="!isOpenOverlay">
                <div v-show="isChooselanguageRequired">
                    <div class="row">
                        <p class="new-account__question">
                            {{ getChooseLanguageTextByResidence }}
                        </p>
                        <div
                            class="field--poland-tax-residence-field__radios new-account__radios"
                        >
                            <Radio
                                :label="
                                    $t(`${TRANSLATION_KEY}.chooseLanguageYes`)
                                "
                                name="chooseLanguage"
                                :value="true"
                                :checked="formData.chooseLanguage"
                                @update-value="
                                    ($event) =>
                                        (formData.chooseLanguage = $event)
                                "
                            />
                            <Radio
                                :label="
                                    $t(`${TRANSLATION_KEY}.chooseLanguageNo`)
                                "
                                name="chooseLanguage"
                                :value="false"
                                :handles-error="false"
                                @update-value="
                                    ($event) =>
                                        (formData.chooseLanguage = $event)
                                "
                            />
                        </div>
                        <a
                            v-show="formData.chooseLanguage"
                            class="button redirect-link"
                            href=""
                        >
                            {{ $t(`${TRANSLATION_KEY}.start`) }}
                        </a>
                        <button
                            v-show="!formData.chooseLanguage"
                            type="button"
                            class="button button--submit"
                            :disabled="formData.chooseLanguage === null"
                            @click="handleChooseLanguage"
                        >
                            {{ $t(`${TRANSLATION_KEY}.saveAndContinue`) }}
                        </button>
                    </div>
                </div>
                <div v-show="!isChooselanguageRequired">
                    <div class="row">
                        <Field
                            v-model="formData.email"
                            type="email"
                            name="email"
                            cy-data="email"
                            :placeholder="
                                $t(`${TRANSLATION_KEY}.emailPlaceholder`)
                            "
                            :allow-all-characters="true"
                            @input="validateEmail"
                            @keydown.enter.prevent="handleEmailEnter"
                        >
                            <span>{{ $t(`${TRANSLATION_KEY}.email`) }}</span>
                        </Field>
                        <button
                            type="button"
                            class="input-icon"
                            aria-label="Clear email"
                            @click="clearInput"
                        >
                            <img src="@/assets/clear-input.svg" alt="" />
                        </button>
                    </div>
                    <div ref="confirmEmail" class="row confirm-email">
                        <p>
                            {{ $t(`${TRANSLATION_KEY}.confirmEmailLabel`) }}
                        </p>
                        <Field
                            v-model="formData.email"
                            type="email"
                            name="confirmEmail"
                            cy-data="confirm-email"
                            :placeholder="
                                $t(`${TRANSLATION_KEY}.emailPlaceholder`)
                            "
                            :disable-paste="true"
                            :disabled="true"
                            :class="isEmailConfirmed ? 'confirmed' : ''"
                            :allow-all-characters="true"
                            @input="validateEmail"
                        />
                    </div>
                    <div class="row confirm-email">
                        <button
                            type="button"
                            v-if="!isEmailConfirmed"
                            :class="[
                                'confirm-email__btn button',
                                isEmailValid ? 'isValid' : 'disabled',
                            ]"
                            data-testid="btn-newAccount-confirmEmail"
                            @click="confirmUserEmail"
                        >
                            {{ $t(`${TRANSLATION_KEY}.saveAndContinue`) }}
                        </button>
                        <span
                            v-else
                            class="button confirm-email__btn confirm-email__btn--confirmed"
                        >
                            <img src="@/assets/tick.svg" alt="" />{{
                                $t(`${TRANSLATION_KEY}.emailIsConfirmed`)
                            }}</span
                        >
                    </div>
                    <transition name="fade" mode="out-in">
                        <div v-if="isEmailConfirmed">
                            <div class="row">
                                <Field
                                    v-model="formData.password"
                                    :type="passwordInputType"
                                    name="password"
                                    cy-data="password"
                                    :placeholder="
                                        $t(
                                            `${TRANSLATION_KEY}.passwordPlaceholder`
                                        )
                                    "
                                    :allow-all-characters="true"
                                    @input="validatePassword"
                                >
                                    <span>{{
                                        $t(`${TRANSLATION_KEY}.password`)
                                    }}</span>
                                </Field>
                                <button
                                    type="button"
                                    v-show="passwordInputType === 'password'"
                                    class="show-password-icon"
                                    aria-label="Show password"
                                    @click="showPassword(true)"
                                >
                                    <img src="@/assets/view.svg" alt="" />
                                </button>
                                <button
                                    type="button"
                                    v-show="passwordInputType === 'text'"
                                    class="show-password-icon"
                                    aria-label="Hide password"
                                    @click="showPassword(false)"
                                >
                                    <img src="@/assets/private.svg" alt="" />
                                </button>
                            </div>
                            <div class="row row--information-password">
                                {{
                                    $t(`${TRANSLATION_KEY}.passwordInformation`)
                                }}
                            </div>
                            <div class="row row--password-indicators">
                                <FillableBullet
                                    class="fs-11"
                                    :is-filled="
                                        validationPass.isContainsEightChars
                                    "
                                >
                                    {{
                                        $t(
                                            `${TRANSLATION_KEY}.passwordRequirementsOne`
                                        )
                                    }}
                                </FillableBullet>
                                <FillableBullet
                                    class="fs-11"
                                    :is-filled="validationPass.isMixedLetters"
                                >
                                    {{
                                        $t(
                                            `${TRANSLATION_KEY}.passwordRequirementsTwo`
                                        )
                                    }}
                                </FillableBullet>
                                <FillableBullet
                                    class="fs-11"
                                    :is-filled="validationPass.isContainsNumber"
                                >
                                    {{
                                        $t(
                                            `${TRANSLATION_KEY}.passwordRequirementsThree`
                                        )
                                    }}
                                </FillableBullet>
                                <FillableBullet
                                    class="fs-11"
                                    :is-filled="
                                        validationPass.isContainsSpecialCharacter
                                    "
                                >
                                    {{
                                        $t(
                                            `${TRANSLATION_KEY}.passwordRequirementsFour`
                                        )
                                    }}
                                </FillableBullet>
                            </div>
                            <div class="row row--password-strength-text">
                                {{ $t(`${TRANSLATION_KEY}.passwordStrength`) }}
                            </div>
                            <div class="row row--with-password-strength">
                                <div
                                    class="progress"
                                    :style="{
                                        width:
                                            validationPass.passwordProgress +
                                            '%',
                                        background:
                                            validationPass.passwordStrength,
                                    }"
                                />
                                <div class="middle-pipe" />
                            </div>
                            <div class="row row--with-agreement">
                                <div class="row__data-regulations">
                                    <CheckBox
                                        v-model="marketingAgreementAll"
                                        name="marketingAgreementAll"
                                        cy-data="marketingAgreementAll"
                                        :value="false"
                                        :onchange="handleToggleAll"
                                        :no-auto-validation="true"
                                    >
                                        <span class="row__privacy-policy">{{
                                            $t(
                                                `${TRANSLATION_KEY}.marketingCheckBoxAcceptAll`
                                            )
                                        }}</span>
                                    </CheckBox>
                                </div>
                                <div class="row__data-information">
                                    <div class="row">
                                        <CheckBox
                                            v-model="
                                                formData.marketingAgreement
                                            "
                                            name="marketingAgreement"
                                            cy-data="marketingAgreement"
                                            :value="false"
                                            :input-size="CheckboxSize.Medium"
                                        >
                                            <span class="row__privacy-policy">
                                                {{
                                                    $t(
                                                        `${TRANSLATION_KEY}.termsAndConditionsOne`
                                                    )
                                                }}
                                                <a
                                                    class="terms-link"
                                                    :href="
                                                        $t(
                                                            `${TRANSLATION_KEY}.termsAndConditionsLink`
                                                        )
                                                    "
                                                    target="_blank"
                                                    >{{
                                                        $t(
                                                            `${TRANSLATION_KEY}.termsAndConditionsTwo`
                                                        )
                                                    }}</a
                                                >
                                                {{
                                                    $t(
                                                        `${TRANSLATION_KEY}.termsAndConditionsThree`
                                                    )
                                                }}
                                                <span class="label-required"
                                                    >*</span
                                                >
                                            </span>
                                        </CheckBox>
                                    </div>

                                    <span class="data-information__text">
                                        {{
                                            $t(
                                                `${TRANSLATION_KEY}.marketingCheckboxTitle`
                                            )
                                        }}
                                    </span>

                                    <div class="row__marketing_checkboxes">
                                        <CheckBox
                                            v-model="
                                                formData.marketingAgreementEmail
                                            "
                                            name="marketingAgreementEmail"
                                            cy-data="marketingAgreementEmail"
                                            :value="false"
                                            :input-size="CheckboxSize.Medium"
                                        >
                                            <span class="row__privacy-policy">{{
                                                $t(
                                                    `${TRANSLATION_KEY}.marketingCheckboxEmail`
                                                )
                                            }}</span>
                                        </CheckBox>

                                        <CheckBox
                                            v-model="
                                                formData.marketingAgreementSms
                                            "
                                            name="marketingAgreementSms"
                                            cy-data="marketingAgreementSms"
                                            :value="false"
                                            :input-size="CheckboxSize.Medium"
                                        >
                                            <span class="row__privacy-policy">{{
                                                $t(
                                                    `${TRANSLATION_KEY}.marketingCheckboxSms`
                                                )
                                            }}</span>
                                        </CheckBox>
                                    </div>
                                </div>
                            </div>

                            <div class="row row__rodo">
                                <button
                                    type="button"
                                    class="link"
                                    @click="handleModal"
                                >
                                    {{ $t(`${TRANSLATION_KEY}.rodoQuestion`) }}
                                </button>
                            </div>
                            <RecaptchaButton
                                :action="Action.NEW_ACCOUNT"
                                :data="formData"
                                :button-value="$t(`${TRANSLATION_KEY}.next`)"
                                data-testid="btn-newAccont-nextStep"
                                class="button button--submit"
                                :disabled="
                                    !(
                                        emailsMatch &&
                                        isEmailValid &&
                                        validationPass.isValidPassword &&
                                        isEmailConfirmed &&
                                        formData.marketingAgreement
                                    )
                                "
                                @click="
                                    () =>
                                        amplitudeSendEvent(
                                            AmplitudeAnalyticsEvents.newLogin
                                                .PASSWORD_CONTINUE
                                        )
                                "
                            />
                        </div>
                    </transition>
                </div>
            </div>
        </form>
        <div v-if="isDetectedMobileDevice" class="cookies-container">
            <Cookies />
        </div>
    </div>
</template>

<script lang="ts">
import {
    defineComponent,
    ref,
    reactive,
    computed,
    watch,
    onMounted,
    onBeforeUnmount,
    getCurrentInstance,
    nextTick,
} from 'vue';
import { useStore } from 'vuex';
import { Locale } from '@/constants/locale';
import { NewAccountInterface } from '@/types.d';
import {
    SET_PROGRESS,
    SET_DARK_BACKGROUND,
    SET_STEP,
} from '@/constants/mutation-types';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import { LanguageCodeByBranchCode } from '@/helpers/i18n';
import { UrlHelper } from '@/helpers/UrlHelper';
import { CountryHelper } from '@/helpers/CountryHelper';
import RodoInformation from '@/components/RodoInformation.vue';
import UkraineResidenceInfo from '@/components/UkraineResidenceInfo.vue';
import UkraineResidencePopup from '@/components/UkraineResidencePopup.vue';
import CheckBox, { CheckboxSize } from '@/components/basic/fields/CheckBox.vue';
import Field from '@/components/basic/fields/Field.vue';
import Radio from '@/components/basic/fields/Radio.vue';
import Popup from '@/components/basic/Popup.vue';
import FillableBullet from '@/components/basic/fields/FillableBullet.vue';
import RecaptchaButton from '@/components/basic/buttons/RecaptchaSubmitButton.vue';
import TheCountrySelect from '@/components/basic/fields/TheCountrySelect.vue';
import SubmitButton from '@/components/basic/buttons/SubmitButton.vue';
import Cookies from '@/components/basic/Cookies.vue';
import {
    AmplitudeAnalyticsEvents,
    amplitudeSendEvent,
    amplitudeSetResidence,
} from '@/utils/AmplitudeAnalyticsEvents';
import { PROGRESS_BAR_TIMES } from '@/constants/progress-bar-times';
import { Action } from '@/constants/ajax';

export default defineComponent({
    name: 'NewAccount',
    components: {
        UkraineResidenceInfo,
        TheCountrySelect,
        Radio,
        RecaptchaButton,
        CheckBox,
        Field,
        SubmitButton,
        Popup,
        RodoInformation,
        FillableBullet,
        UkraineResidencePopup,
        Cookies,
    },
    setup() {
        const store = useStore();
        const instance = getCurrentInstance();

        const isOpenOverlay = ref<boolean>(true);
        const isConfirmResidence = ref<boolean>(false);
        const isResidenceConfirmRadioRequired = ref<boolean>(
            UtilityHelper.getLocale() !== Locale.EN
        );
        const isChooselanguageRequired = ref<boolean>(false);
        const isRodoInformationOpen = ref<boolean>(false);
        const isUkraineResidenceInfoOpen = ref<boolean>(false);
        const isEmailValid = ref<boolean>(false);
        const emailsMatch = ref<boolean>(false);
        const showUaPopup = ref<boolean>(false);
        const passwordInputType = ref<'password' | 'text'>('password');
        const isEmailConfirmed = ref<boolean>(false);
        const isMobile = ref<boolean>(false);
        const isSamsung = ref<boolean>(false);

        const videoDesktopUrl = ref<string>(
            ''
        );
        const videoMobileUrl = ref<string>(
            ''
        );
        const posterDesktop = ref<string>(
            '@/assets/posters/OANDA/OANDA_Onboarding_HeaderAnim_NoTiles_EN.png'
        );
        const posterMobile = ref<string>(
            '@/assets/posters/OANDA/OANDA_Onboarding_HeaderAnim_NoTiles_EN.png'
        );

        const confirmEmailEl = ref<HTMLElement | null>(null);
        const videoEl = ref<HTMLVideoElement | null>(null);

        const formData = reactive<NewAccountInterface>({
            residenceConfirm: null,
            residenceCountry: '',
            chooseLanguage: false,
            email: '',
            confirmEmail: '',
            password: '',
            marketingAgreement: false,
            marketingAgreementEmail: false,
            marketingAgreementSms: false,
            recaptchaToken: '',
        });

        const isSelectResidenceRequired = computed<boolean>(
            () =>
                !isResidenceConfirmRadioRequired.value ||
                formData.residenceConfirm === false
        );

        const marketingAgreementAll = ref<boolean>(false);

        const validationPass = reactive<{
            flag: number;
            passwordStrength: string;
            passwordProgress: number;
            isMixedLetters: boolean;
            isContainsNumber: boolean;
            isContainsEightChars: boolean;
            isContainsSpecialCharacter: boolean;
            isValidPassword: boolean;
        }>({
            flag: 0,
            isValidPassword: false,
            isMixedLetters: false,
            isContainsNumber: false,
            isContainsEightChars: false,
            isContainsSpecialCharacter: false,
            passwordStrength: '',
            passwordProgress: 0,
        });

        const TRANSLATION_KEY = 'steps.NewAccount';

        const countries = computed(() => {
            let c = JSON.parse(JSON.stringify(store.state.config.countries));
            const index = c.findIndex(
                (num: { key: string }) =>
                    num.key === instance?.proxy?.$i18n.locale.toUpperCase()
            );
            if (index >= 0) {
                c.splice(index, 1);
            }
            return c;
        });
        const defaultCountry = computed(() =>
            String(store.state.formData.country || '')
        );

        const isProhibitedCountry = computed(() => {
            return store.state.config.prohibitedCountries.includes(
                formData.residenceCountry
            );
        });

        const getChooseLanguageTextByResidence = computed(() => {
            let citizenshipCode = formData.residenceCountry;
            if (!citizenshipCode)
                return instance?.proxy?.$t(
                    'steps.NewAccount.chooseLanguageTextEN'
                );

            citizenshipCode = citizenshipCode[0] + citizenshipCode.slice(1);
            const tKey = `steps.NewAccount.chooseLanguageText${citizenshipCode}`;
            const fallback = 'steps.NewAccount.chooseLanguageTextEN';

            const possibleTranslation = instance?.proxy?.$t(tKey);
            if (possibleTranslation !== tKey) {
                return possibleTranslation;
            }
            return instance?.proxy?.$t(fallback);
        });

        const isLocked = computed(() => store.state.isLocked);
        const isDetectedMobileDevice = computed(
            () => store.state.isDetectedMobileDevice
        );
        const detectedCountry = computed(() =>
            instance?.proxy?.$i18n.locale.toUpperCase()
        );

        function checkIsSamsung(): void {
            const ua = window.navigator.userAgent;
            if (ua.includes('SamsungBrowser') || ua.includes('SAMSUNG')) {
                isSamsung.value = true;
            }
        }

        function handleModal(): void {
            isRodoInformationOpen.value = !isRodoInformationOpen.value;
            store.commit(SET_DARK_BACKGROUND, isRodoInformationOpen.value);
        }

        function validatePassword(): void {
            nextTick(() => {
                const password = formData.password;
                const {
                    isMixedLetters,
                    isContainsNumber,
                    isContainsEightChars,
                    isContainsSpecialCharacter,
                } = validationPass;

                const regExp: RegExp[] = [
                    /([a-z].*[A-Z])|([A-Z].*[a-z])/,
                    /[0-9]/,
                    /.{8,}/,
                    /[-@#!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/,
                ];

                // Dla liter małych/wielkich
                if (regExp[0].test(password)) {
                    if (!isMixedLetters)
                        makePasswordProgress('+', 'isMixedLetters');
                } else {
                    if (isMixedLetters)
                        makePasswordProgress('-', 'isMixedLetters');
                }

                // Dla cyfr
                if (regExp[1].test(password)) {
                    if (!isContainsNumber)
                        makePasswordProgress('+', 'isContainsNumber');
                } else {
                    if (isContainsNumber)
                        makePasswordProgress('-', 'isContainsNumber');
                }

                // Dla minimalnej długości 8
                if (regExp[2].test(password)) {
                    if (!isContainsEightChars)
                        makePasswordProgress('+', 'isContainsEightChars');
                } else {
                    if (isContainsEightChars)
                        makePasswordProgress('-', 'isContainsEightChars');
                }

                // Dla znaków specjalnych
                if (regExp[3].test(password)) {
                    if (!isContainsSpecialCharacter)
                        makePasswordProgress('+', 'isContainsSpecialCharacter');
                } else {
                    if (isContainsSpecialCharacter)
                        makePasswordProgress('-', 'isContainsSpecialCharacter');
                }

                checkIsValidPass();
                showPasswordProgress();
            });
        }

        function showPasswordProgress(): void {
            const flag = validationPass.flag;
            if (flag === 1) {
                validationPass.passwordStrength = '#af251b';
            } else if (flag === 2 || flag === 3) {
                validationPass.passwordStrength = '#f7b71d';
            } else if (flag === 4) {
                validationPass.passwordStrength = '#339d36';
            }
        }

        function makePasswordProgress(
            operation: string,
            regExpName: string
        ): void {
            if (operation === '+') {
                validationPass.flag += 1;
                (validationPass as any)[regExpName] = true;
                validationPass.passwordProgress += 25;
            } else {
                validationPass.flag -= 1;
                (validationPass as any)[regExpName] = false;
                validationPass.passwordProgress -= 25;
            }
        }

        function checkIsValidPass(): void {
            const {
                isMixedLetters,
                isContainsNumber,
                isContainsEightChars,
                isContainsSpecialCharacter,
            } = validationPass;
            validationPass.isValidPassword = !!(
                isContainsEightChars &&
                isContainsNumber &&
                isMixedLetters &&
                isContainsSpecialCharacter
            );
        }

        function validateEmail(): void {
            nextTick(() => {
                const email = formData.email;
                const regExp =
                    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                isEmailValid.value = regExp.test(email);
                emailsMatch.value = formData.email === formData.confirmEmail;
            });
        }

        function handleResidenceConfirm(): void {
            if (formData.residenceConfirm) {
                formData.residenceCountry =
                    instance?.proxy?.$i18n.locale.toUpperCase() || '';
                residenceReview();
                if (formData.residenceCountry !== 'UA') {
                    isOpenOverlay.value = false;
                }
            } else {
                if (
                    LanguageCodeByBranchCode.hasOwnProperty(
                        formData.residenceCountry.toLowerCase()
                    )
                ) {
                    if (formData.residenceCountry === 'UA') {
                        handleUkraineResidenceInfoOpen();
                    } else {
                        isChooselanguageRequired.value =
                            formData.residenceCountry === 'RO' ? false : true;
                        isOpenOverlay.value = false;
                        amplitudeSendEvent(
                            AmplitudeAnalyticsEvents.newLogin.LANGUAGE
                        );
                    }
                } else if (
                    !CountryHelper.isEuropeanCountry(formData.residenceCountry)
                ) {
                    const url = UrlHelper.getRedirectUrlByResidence(
                        formData.residenceCountry
                    );
                    window.location.replace(url);
                } else {
                    isOpenOverlay.value = false;
                    isConfirmResidence.value = true;
                }
            }
            store.state.residenceCountry = formData.residenceCountry;
            store.state.analyticsService.analyticsData.residency =
                formData.residenceCountry;
            store.state.analyticsService.sendStepEvent('residenceConfirm');
            store.state.analyticsService.sendStepEvent('newRegistration');
            amplitudeSendEvent(
                AmplitudeAnalyticsEvents.newLogin.RESIDENCE_CONTINUE
            );
            amplitudeSendEvent(AmplitudeAnalyticsEvents.newLogin.EMAIL);
            amplitudeSetResidence(formData.residenceCountry);
            window.scrollTo(0, 0);
        }

        function updateResidenceConfirm(
            value: boolean,
            resetResidenceCountry = false
        ): void {
            formData.residenceConfirm = value;

            if (resetResidenceCountry) {
                formData.residenceCountry = '';
            }
        }

        function handleChooseLanguage(): void {
            if (!formData.chooseLanguage) {
                isOpenOverlay.value = false;
                isChooselanguageRequired.value = false;
            }
            store.state.analyticsService.sendStepEvent('chooseLanguage');
            window.scrollTo(0, 0);
        }

        function handleUkraineResidenceInfoOpen(): void {
            showUaPopup.value = !showUaPopup.value;
        }

        function residenceReview(): void {
            if (formData.residenceCountry === 'UA') {
                handleUkraineResidenceInfoOpen();
            } else {
                isConfirmResidence.value = true;
            }
        }

        function yesEuAddress(): void {
            showUaPopup.value = false;
            formData.residenceConfirm = false;
        }

        function showPassword(action: boolean): void {
            if (action) {
                passwordInputType.value = 'text';
            } else {
                passwordInputType.value = 'password';
            }
        }

        function clearInput(): void {
            formData.email = '';
        }

        async function handleEmailEnter(): Promise<void> {
            if (!isEmailValid.value || isEmailConfirmed.value) {
                return;
            }

            await confirmUserEmail();
        }

        async function confirmUserEmail(): Promise<void> {
            if (!isEmailValid.value || isEmailConfirmed.value) {
                return;
            }

            amplitudeSendEvent(
                AmplitudeAnalyticsEvents.newLogin.EMAIL_CONTINUE
            );
            await store.dispatch('ajax', {
                action: Action.EXISTING_ACCOUNT,
                data: { email: formData.email },
            });

            if (store.state.currentStep === 'newLogin') {
                return;
            }

            isEmailConfirmed.value = true;
            if (confirmEmailEl.value) {
                confirmEmailEl.value.classList.add('email-confirmed');
            }
            amplitudeSendEvent(AmplitudeAnalyticsEvents.newLogin.PASSWORD);
        }

        function writeUrlParams(): void {
            const urlParams = window.location.search;
            if (urlParams && urlParams !== '?from=HP_UP') {
                store.state.AdjustUrlParams = urlParams;
            }
        }

        function onResize(): void {
            isMobile.value = window.innerWidth < 768;
        }

        function replaceVideoUrl(): void {
            const locale = UtilityHelper.getLocale().toUpperCase();
            const version = UtilityHelper.isOandaPath() ? 'OANDA' : 'OTMS';
            videoDesktopUrl.value = `https://storage.googleapis.com/oanda-prod-tms-tms-marketing/proxy/videos/${version}/${version}_Onboarding_HeaderAnim_NoTiles_${locale}.mp4`;
            videoMobileUrl.value = `https://storage.googleapis.com/oanda-prod-tms-tms-marketing/proxy/videos/${version}/${version}_Onboarding_HeaderAnim_${locale}.mp4`;
            posterDesktop.value = `@/assets/posters/${version}/${version}_Onboarding_HeaderAnim_NoTiles_${locale}.png`;
            posterMobile.value = `@/assets/posters/${version}/${version}_Onboarding_HeaderAnim_${locale}.png`;
        }

        function getMobilePoster() {
            const locale = UtilityHelper.getLocale().toUpperCase();
            const version = UtilityHelper.isOandaPath() ? 'OANDA' : 'OTMS';
            return require(
                `@/assets/posters/${version}/${version}_Onboarding_HeaderAnim_${locale}.png`
            );
        }

        function handleVideoError(): void {
            isSamsung.value = true;
        }

        function handleToggleAll(event: Event) {
            const checked = (event.target as HTMLInputElement).checked;
            formData.marketingAgreementEmail = checked;
            formData.marketingAgreementSms = checked;
            formData.marketingAgreement = checked;
        }

        watch(
            () => [
                formData.marketingAgreementEmail,
                formData.marketingAgreementSms,
                formData.marketingAgreement,
            ],
            ([email, sms, regulations]) => {
                const allChecked = email && sms && regulations;
                if (marketingAgreementAll.value !== allChecked)
                    marketingAgreementAll.value = allChecked;
            }
        );

        function handleClick(): void {
            store.commit(SET_STEP, 'newLogin');
            amplitudeSendEvent(AmplitudeAnalyticsEvents.newLogin.GO_TO_LOGIN);
        }

        watch(
            () => formData.email,
            () => {
                formData.confirmEmail = formData.email;
                isEmailConfirmed.value = false;
                if (confirmEmailEl.value) {
                    confirmEmailEl.value.classList.remove('email-confirmed');
                }
            }
        );

        watch(
            () => formData.residenceCountry,
            (newVal) => {
                const localesArray = String(Object.values(Locale));
                if (localesArray.includes(newVal.toLowerCase())) {
                    formData.chooseLanguage = true;
                }
                store.state.residenceCountry = newVal;
            }
        );

        watch(
            () => formData.chooseLanguage,
            (newVal) => {
                if (newVal) {
                    const redirectUrl = UrlHelper.getRedirectUrlByResidence(
                        formData.residenceCountry
                    );
                    const redirectLink =
                        document.querySelector('.redirect-link');
                    if (redirectLink) {
                        redirectLink.setAttribute('href', redirectUrl);
                    }
                }
            }
        );

        watch(isMobile, (val) => {
            if (videoEl.value) {
                videoEl.value.src = '';
            }
            setTimeout(() => {
                if (!videoEl.value) return;
                videoEl.value.src = val
                    ? videoMobileUrl.value
                    : videoDesktopUrl.value;
                videoEl.value.play();
            });
        });

        onMounted(() => {
            store.state.analyticsService.sendStepEvent('');

            store.state.ajaxService.restart();
            store.commit(SET_PROGRESS, PROGRESS_BAR_TIMES.NEW_ACCOUNT);
            localStorage.setItem('reloaded', 'false');

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const country = urlParams.get('lang');

            if (country && LanguageCodeByBranchCode.hasOwnProperty(country)) {
                formData.residenceCountry = country.toUpperCase();
                formData.residenceConfirm = false;
                isOpenOverlay.value = false;
                isConfirmResidence.value = true;
                store.state.residenceCountry = formData.residenceCountry;
                amplitudeSendEvent(AmplitudeAnalyticsEvents.newLogin.EMAIL);
            }

            if (
                isResidenceConfirmRadioRequired.value &&
                UtilityHelper.getLocale() !== Locale.UA
            ) {
                formData.residenceConfirm = true;
            }

            writeUrlParams();
            replaceVideoUrl();

            const videoInterval = setInterval(() => {
                if (!isLocked.value) {
                    clearInterval(videoInterval);
                    setTimeout(() => {
                        if (videoEl.value) {
                            videoEl.value.play();
                        }
                    }, 200);
                }
            }, 100);

            onResize();
            window.addEventListener('resize', onResize, { passive: true });
            checkIsSamsung();
        });

        onBeforeUnmount(() => {
            window.removeEventListener('resize', onResize);
        });

        return {
            // Refs
            confirmEmailEl,
            videoEl,
            marketingAgreementAll,

            isOpenOverlay,
            isConfirmResidence,
            isResidenceConfirmRadioRequired,
            isSelectResidenceRequired,
            isChooselanguageRequired,
            isRodoInformationOpen,
            isUkraineResidenceInfoOpen,
            isEmailValid,
            emailsMatch,
            showUaPopup,
            passwordInputType,
            isEmailConfirmed,
            isMobile,
            isSamsung,
            isProhibitedCountry,

            videoDesktopUrl,
            videoMobileUrl,
            posterDesktop,
            posterMobile,

            formData,
            validationPass,
            TRANSLATION_KEY,

            countries,
            defaultCountry,
            getChooseLanguageTextByResidence,
            isLocked,
            isDetectedMobileDevice,
            detectedCountry,

            checkIsSamsung,
            handleModal,
            validatePassword,
            showPasswordProgress,
            makePasswordProgress,
            checkIsValidPass,
            validateEmail,
            handleEmailEnter,
            handleResidenceConfirm,
            updateResidenceConfirm,
            handleChooseLanguage,
            handleUkraineResidenceInfoOpen,
            residenceReview,
            yesEuAddress,
            showPassword,
            clearInput,
            confirmUserEmail,
            writeUrlParams,
            onResize,
            replaceVideoUrl,
            getMobilePoster,
            UtilityHelper,
            Locale,
            amplitudeSendEvent,
            AmplitudeAnalyticsEvents,
            Action,
            CheckboxSize,
            handleVideoError,
            handleToggleAll,
            handleClick,
        };
    },
});
</script>

<style lang="scss" scoped>
form {
    padding: 30px 22px !important;
    @media (min-width: 500px) {
        padding: 30px 20px !important;
    }
}
.samsung-mobile {
    margin-bottom: 10px !important;
}

.input-wrapper--marketingAgreement {
    background-color: inherit !important;
}

.terms-link {
    display: inline-block;
    padding: 1px 3px;
    border-radius: 4px;
}

.terms-link:focus,
.terms-link:focus-visible {
    outline: 2px solid #192241 !important;
    outline-offset: 2px;
}
</style>
